/* 
	该模块是用于定义action对象中type类型的常量值，目的只有一个：便于管理的同时防止程序员单词写错
*/

import {post_user} from "./actions/user";

export const PUSER = 'post_user';
